var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-left"},[_c('h4',[_vm._v("\n      "+_vm._s(_vm.$t('home.welcome.greeting', { greetingName: _vm.greetingName }))+"\n    ")]),_c('h6',[_vm._v(_vm._s(_vm.$t('home.welcome.message')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }